import { render, staticRenderFns } from "./CommandesClient.vue?vue&type=template&id=3c1d23c2"
import script from "./CommandesClient.vue?vue&type=script&lang=js"
export * from "./CommandesClient.vue?vue&type=script&lang=js"
import style0 from "./CommandesClient.vue?vue&type=style&index=0&id=3c1d23c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports